import { useEffect, useState } from "react"

function useOnline(): boolean {
  const [isOnline, setIsOnline] = useState<boolean>(navigator.onLine)

  useEffect(() => {
    fetch("/favicon.ico?d=" + Date.now())
      .then(response => {
        if (!response.ok) throw new Error("Network response was not ok")

        // At this point we can safely assume the user has connection to the internet
        console.log("Internet connection available")
      })
      .catch(error => {
        // The resource could not be reached
        setIsOnline(false)
        console.log("No Internet connection", error)
      })
  }, [])

  return isOnline
}

export default useOnline
